import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { PageLoader } from 'routes/PrivateRouter';
import {
  integrationsURLs,
  type IntegrationsTab,
} from 'routes/integrations/integrationsURLs';

import { PermissionGuard } from 'components/PermissionGuard';

const Integrations = lazy(() =>
  import('pages/central-data-hub/integrations/Integrations').then((m) => ({
    default: m.Integrations,
  }))
);

const IntegrationsRouteElement = ({ tab }: { tab: IntegrationsTab }) => (
  <PermissionGuard moduleKey="integrations">
    <Suspense fallback={<PageLoader />}>
      <Integrations tab={tab} />
    </Suspense>
  </PermissionGuard>
);

export const IntegrationsRoutes = {
  path: integrationsURLs._base_relative_path,
  children: [
    {
      index: true,
      element: <Navigate to={integrationsURLs.active} replace />,
    },
    {
      path: integrationsURLs._active_relative_path,
      element: <IntegrationsRouteElement tab="active" />,
    },
    {
      path: integrationsURLs._available_relative_path,
      element: <IntegrationsRouteElement tab="available" />,
    },
  ],
};
